import Table from 'react-bootstrap/Table';
import './skeleton.css';

export default function SkeletonTable({ rows = 6, columns = 4 }) {
  return (
    <Table hover responsive className="mb-0 roles-table skeleton-table">
      <colgroup>
        {Array(columns)
          .fill(0)
          .map((_, idx) => (
            <col key={idx} />
          ))}
      </colgroup>

      <thead>
        <tr>
          {Array(columns)
            .fill(0)
            .map((_, idx) => (
              <th key={idx}>
                <div className="skeleton skeleton-header"></div>
              </th>
            ))}
        </tr>
      </thead>

      <tbody>
        {Array(rows)
          .fill(0)
          .map((_, rowIdx) => (
            <tr key={rowIdx}>
              {Array(columns)
                .fill(0)
                .map((_, colIdx) => (
                  <td key={colIdx}>
                    <div className="skeleton skeleton-cell"></div>
                  </td>
                ))}
            </tr>
          ))}
      </tbody>
    </Table>
  );
}
